export enum StatusReport {
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  IN_PROGRESS = 'IN_PROGRESS',
}

export interface ReportFile {
  id: number;
  path: string;
  name: string;
  created_at: Date | null;
  updated_at: Date | null;
}


export interface ReportType {
  status: StatusReport;
  name: string;
  id: number;
  count_files: number;
  created_at: Date | null;
  updated_at: Date | null;
  files: ReportFile[];
  status_message: string | null;
  requested_by: string;
}
